module.exports = __webpack_public_path__ + "static/media/yt.5f1aadbb.svg";